import { apiProductNatures } from '@spo/services/api';
import { useMutation } from '@tanstack/react-query';

export const useAddSportProductNatures = (
  sportId: number,
  productNatureIds: number[],
  onSuccess: () => void,
  onError: () => void,
) => {
  return useMutation({
    mutationKey: ['useAddSportProductNatures', productNatureIds],
    mutationFn: () =>
      apiProductNatures.addProductNatures({
        sportId,
        productNatureIds,
        language: 'EN',
      }),
    onSuccess,
    onError,
  });
};
